export default "/assets/images/purely-white-sm.webp?73da42ffe0c68a83210d91da8195d65c";